import { styled } from "baseui";
import { Link } from "react-router-dom";

const RouteLink = styled(Link, ({ secondary, $theme }) => ({
  color: secondary ? "#919191" : $theme.colors.accent,
}));

export default RouteLink;
